import { AbstractClient, CompositionClient } from "@/app/client";
import {
  ERPExportStatus,
  QueueExportResponse,
  ExportActionResponse,
} from "@/app/types";

/**
 * ERP Export API Client
 *
 * Generic ERP export operations - provider-agnostic
 * The actual ERP system (AS400, Sage, etc.) is determined by backend configuration
 */
export default class APIExportsSub extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  /**
   * Queue a pre-order for ERP export
   */
  queueExport = async (preOrderId: string): Promise<QueueExportResponse> => {
    let res = await this._fetch({
      url: `/pre-orders/${preOrderId}/queue-export`,
      method: "POST",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  /**
   * Get export status for a pre-order
   */
  getExportStatus = async (preOrderId: string): Promise<ERPExportStatus> => {
    let res = await this._fetch({
      url: `/pre-orders/${preOrderId}/export-status`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  /**
   * Manually retry a failed export
   */
  retryExport = async (preOrderId: string): Promise<ExportActionResponse> => {
    let res = await this._fetch({
      url: `/pre-orders/${preOrderId}/retry-export`,
      method: "POST",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  /**
   * Cancel a pending or retry export
   */
  cancelExport = async (preOrderId: string): Promise<ExportActionResponse> => {
    let res = await this._fetch({
      url: `/pre-orders/${preOrderId}/cancel-export`,
      method: "POST",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
